<template>
	<div class="core-embed">
		<video-embed :src="block.attrs.url" :css="aspectClass"></video-embed>
	</div>
</template>

<script>
export default {
	props: ['block', 'parentBlock'],
	computed: {
		aspectClass() {
			const cls = this.block.attrs.className || '';
			if (cls.includes('aspect-21-9')) return 'embed-responsive-21by9';
			if (cls.includes('aspect-4-3')) return 'embed-responsive-4by3';
			if (cls.includes('aspect-1-1')) return 'embed-responsive-1by1';
			if (cls.includes('aspect-9-16')) return 'embed-responsive-9by16';
			return 'embed-responsive-16by9';
		},
	},
};
</script>

<style lang="scss">
.core-embed {
	max-width: 900px;
	width: 100%;
	margin: auto;

	.embed-responsive {
		position: relative;
		width: 100%;
		aspect-ratio: 16 / 9;
		overflow: hidden;
		background: $aili-black;

		&.embed-responsive-21by9 { aspect-ratio: 21 / 9; }
		&.embed-responsive-4by3 { aspect-ratio: 4 / 3; }
		&.embed-responsive-1by1 { aspect-ratio: 1 / 1; }
		&.embed-responsive-9by16 { aspect-ratio: 9 / 16; max-width: 400px; margin: 0 auto; }

		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border: 0;
		}
	}

}

.core_embed + .core_embed {
	margin-top: 1rem;
}
</style>
